<template>
  <v-popup>
    <div class="error-popup">
      <h2>{{ title || this.$t("common.errorduringsave") }}</h2>
      <p>{{ description }}</p>
      <div class="error-popup__buttons">
        <v-button primary @click="$emit('close')">
          {{ submitButtonText ? this.$t(submitButtonText) : "OK" }}
        </v-button>
      </div>
    </div>
  </v-popup>
</template>

<script>
import { VPopup, VButton } from "shared";
export default {
  name: "VErrorPopup",
  components: {
    VPopup,
    VButton,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: undefined,
    },
    submitButtonText: {
      type: String,
      default: undefined,
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .popup {
  &__container {
    min-width: 0;
    padding: 75px 0 45px 0;
    width: 443px;
  }
}
.error-popup {
  text-align: center;
  h2 {
    font-size: 16px;
    line-height: 17px;
    margin-bottom: 15px;
  }
  p {
    font-size: 13px;
    line-height: 16px;
  }
  &__buttons {
    margin: 45px 0 0 0;
    display: flex;
    justify-content: center;
  }
}
</style>
